export default __webpack_public_path__ + "static/media/28.c9e0acf5.png";